module.exports = __webpack_public_path__ + "media/images/glasses_small-6223ae20cc90b3beb547f20edc9434a6.svg";